import { TypedUseSelectorHook, useSelector } from 'react-redux'
import { combineReducers } from 'redux'

import { middlewareReducer } from './combineMiddlewareLogic'
import { StateInterface } from './Interfaces/StateInterface'
import reducers from './reducers'

export const useTypedSelector: TypedUseSelectorHook<StateInterface> = useSelector

const reducer = combineReducers<StateInterface>(reducers)

export default (state: StateInterface, action) => {
  const reducedState = reducer(state, action)
  return middlewareReducer(reducedState, action) as StateInterface
}
